import React from 'react';
import { Col, Form } from 'react-bootstrap';

// Anio de Egreso
const AnioEgresoSelect = ({ c, i, handleInputChange, valuesRequired }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group>
        <Form.Label>{c.name + ' *'}</Form.Label>
        <Form.Control
          as="select"
          name="anioEgreso"
          onChange={handleInputChange}
          required={true}
          defaultValue="-1"
          className="form-control"
          isValid={valuesRequired.anioEgreso !== undefined}
        >
          <option value="-1" disabled>
            {c.placeholder}
          </option>
          <option value={currentYear + 2}>{currentYear + 2}</option>
          <option value={currentYear + 1}>{currentYear + 1}</option>
          <option value={currentYear}>{currentYear}</option>
          <option value={currentYear - 1}>{currentYear - 1}</option>
          <option value={currentYear - 2}>{currentYear - 2}</option>
          <option value={currentYear - 3}>{currentYear - 3}</option>
          <option value={2000}>{'Egresado en otro año'}</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Seleccione {c.name} por favor
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default AnioEgresoSelect;
